import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

const departementsSenegal = [
  'Dakar',
  'Pikine',
  'Guédiawaye',
  'Rufisque',
  'Thiès',
  'Mbour',
  'Tivaouane',
  'Saint-Louis',
  'Dagana',
  'Podor',
  'Matam',
  'Kanel',
  'Ranérou',
  'Diourbel',
  'Mbacké',
  'Bambey',
  'Fatick',
  'Foundiougne',
  'Gossas',
  'Kaolack',
  'Nioro du Rip',
  'Guinguinéo',
  'Kaffrine',
  'Koungheul',
  'Malem Hoddar',
  'Birkelane',
  'Louga',
  'Kébémer',
  'Linguère',
  'Tambacounda',
  'Bakel',
  'Goudiry',
  'Koumpentoum',
  'Kédougou',
  'Salémata',
  'Saraya',
  'Ziguinchor',
  'Bignona',
  'Oussouye',
  'Kolda',
  'Vélingara',
  'Médina Yoro Foulah',
  'Sédhiou',
  'Bounkiling',
  'Goudomp',
];

const DepartementSelect = () => {
  const handleChange = (value) => {
    console.log(`Selected: ${value}`);
  };

  return (
    <Select
      showSearch
      style={{ width: "100%" }}
      placeholder="Sélectionnez un département"
      optionFilterProp="children"
      onChange={handleChange}
      filterOption={(input, option) =>
        option?.children.toLowerCase().includes(input.toLowerCase())
      }
    >
      {departementsSenegal.map((departement) => (
        <Option key={departement} value={departement}>
          {departement}
        </Option>
      ))}
    </Select>
  );
};

export default DepartementSelect;
